import { ReactNode } from "react";
import styles from "assets/shared-stylesheets/sparket-list-item.module.css";
import shellStyles from "./shell.module.css";
import { useAppSelector } from "state/hooks";
import { getCardColor, getTextColor } from "state/slices/group-slice";

interface Props {
  children: ReactNode;
}

/**
 * Reproduces the outer container of the back side of the bet card exactly as
 * HomepageBetForm does — pulling cardColor / textColor from the current
 * group customization so the dev page reflects whichever group is loaded.
 *
 * Production uses the `cardFlipBack` class (rotateY 180deg) because the back
 * face sits inside a flip container that's also rotated, so the two cancel
 * out. On this dev page there's no flip container — we render the back face
 * directly. Instead we add a flip-in animation on mount so the "Replay flip"
 * action produces visible feedback for every variant.
 */
const BackCardShell = ({ children }: Props) => {
  const cardColor = useAppSelector(getCardColor);
  const textColor = useAppSelector(getTextColor);

  return (
    <div
      className={`${styles.itemContainer} ${shellStyles.flipIn}`}
      style={{
        marginLeft: 0,
        marginRight: 0,
        minHeight: 250,
        fontSize: 12,
        backgroundColor: cardColor,
        color: textColor,
      }}
    >
      <div
        style={{
          width: "100%",
          padding: 5,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default BackCardShell;
